import { render } from "./CodeFail.vue?vue&type=template&id=d82f29ea"
import script from "./CodeFail.vue?vue&type=script&lang=js"
export * from "./CodeFail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__